import * as stylex from '@stylexjs/stylex';
import { colors } from '@shared/tokens/colors.stylex';

export const styles = stylex.create({
  tiptap: {
    width: '100%',
    overflow: 'hidden',
    cursor: 'auto',
    ':not(#__unused__) div[contenteditable=false]::before': {
      content: 'attr(data-placeholder)',
      color: colors.secondaryText,
      pointerEvents: 'none',
      height: '0',
      position: 'absolute',
      left: '50%',
      transform: 'translateX(-50%)',
    },
    ':not(#__unused__) .is-editor-empty:first-child::before': {
      content: 'attr(data-placeholder)',
      color: colors.secondaryText,
      pointerEvents: 'none',
      height: '0',
      position: 'static',
    },
    ':not(#__unused__) .ProseMirror-focused .is-editor-empty:first-child::before': {
      content: '',
    },
    ':not(#__unused__) .ProseMirror-focused.is-editor-empty:first-child::before': {
      content: '',
    },
  },
});
